import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";
import {
    FiX,
    FiUser,
    FiSettings,
    FiShoppingBag,
    FiHome,
    FiZap,
    FiLogOut
} from "react-icons/fi";
import { deleteToken } from "../services/cookies";

const Sidebar = ({ isOpen, onClose, profileData }) => {
    const navigate = useNavigate();
    const { id } = useParams();

    const menuItems = [
        { icon: <FiHome />, label: "Ana Sayfa", path: `/${id}/module-list` },
        { icon: <FiZap className="text-[#3DA7B5]" />, label: "JT Bakiyem", path: `/${id}/settings/token-balance` },
        { icon: <FiUser />, label: "Profilim", path: `/${id}/settings/profile` },
        { icon: <FiSettings />, label: "Ayarlar", path: `/${id}/settings` },
        { icon: <FiShoppingBag />, label: "Market", path: `/${id}/store` },
    ];

    const handleLogout = () => {
        deleteToken("jodiactoken");
        navigate(`/${id}/login`);
    };

    const sidebarVariants = {
        closed: { x: "-100%", transition: { type: "spring", stiffness: 300, damping: 30 } },
        open: { x: 0, transition: { type: "spring", stiffness: 300, damping: 30 } }
    };

    const backdropVariants = {
        closed: { opacity: 0 },
        open: { opacity: 1 }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={backdropVariants}
                        onClick={onClose}
                        className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[100]"
                    />

                    {/* Sidebar */}
                    <motion.div
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={sidebarVariants}
                        className="fixed top-0 left-0 bottom-0 w-[280px] bg-white z-[101] shadow-2xl flex flex-col"
                    >
                        {/* Header / Profile Info */}
                        <div className="p-8 bg-gradient-to-br from-[#3DA7B5] to-[#2a8a96] text-white relative">
                            <button
                                onClick={onClose}
                                className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-full transition-all"
                            >
                                <FiX size={24} />
                            </button>

                            <div className="flex flex-col items-start gap-4 mt-4">
                                <div className="w-16 h-16 rounded-2xl border-2 border-white/50 overflow-hidden bg-white/20 backdrop-blur-md flex items-center justify-center">
                                    {profileData?.pictureDetails?.pictureUrl ? (
                                        <img
                                            src={profileData.pictureDetails.pictureUrl}
                                            alt="Profile"
                                            className="w-full h-full object-cover"
                                        />
                                    ) : (
                                        <span className="text-2xl font-black text-white">
                                            {profileData?.first_name?.charAt(0)}{profileData?.last_name?.charAt(0)}
                                        </span>
                                    )}
                                </div>
                                <div className="text-left w-full">
                                    <p className="text-white/70 text-sm font-medium mb-0.5">Hoş geldin,</p>
                                    <h3 className="font-black text-xl leading-tight">
                                        {profileData?.first_name} {profileData?.last_name}
                                    </h3>
                                </div>
                            </div>
                        </div>

                        {/* Menu Items */}
                        <div className="flex-1 overflow-y-auto px-4 py-8 space-y-2">
                            {menuItems.map((item, index) => (
                                <button
                                    key={index}
                                    onClick={() => {
                                        navigate(item.path);
                                        onClose();
                                    }}
                                    className="w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl text-gray-600 hover:bg-[#3DA7B5]/5 hover:text-[#3DA7B5] transition-all group"
                                >
                                    <span className="text-xl group-hover:scale-110 transition-transform">
                                        {item.icon}
                                    </span>
                                    <span className="font-bold text-[15px]">{item.label}</span>
                                </button>
                            ))}
                        </div>

                        {/* Footer / Logout */}
                        <div className="p-6 border-t border-gray-100">
                            <button
                                onClick={handleLogout}
                                className="w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl text-red-500 hover:bg-red-50 transition-all font-bold"
                            >
                                <FiLogOut size={20} />
                                <span>Çıkış Yap</span>
                            </button>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default Sidebar;
